const PREFS = [["telefoon", "Telefonisch"], ["email", "Per e-mail"], ["geen", "Geen voorkeur"]];
const MOMENTS = [["ochtend", "Ochtend", "09.00–12.00 uur"], ["middag", "Middag", "12.00–17.00 uur"], ["avond", "Avond", "17.00–20.00 uur"], ["geen", "Geen voorkeur", ""]];

const Choice = ({ name, value, checked, onChange, label, hint, testid }) => (
  <label data-testid={testid} className={`flex cursor-pointer flex-col items-center justify-center rounded-lg border px-2 py-2 text-center text-[13.5px] transition-colors has-[:focus-visible]:ring-2 has-[:focus-visible]:ring-maas/40 ${checked ? "border-maas bg-maas-soft font-semibold text-maas-deep" : "border-slate-300 bg-white text-slate-700 hover:border-slate-400"}`}>
    <input type="radio" name={name} value={value} checked={checked} onChange={() => onChange(value)} className="sr-only" />
    {label}{hint && <span className="text-[11.5px] font-normal text-slate-500">{hint}</span>}
  </label>
);

// Optionele contactvoorkeur van de bezoeker; dit is een voorkeur, geen afspraak.
export const ContactPreference = ({ pref, moment, onPref, onMoment }) => (
  <fieldset data-testid="isde-review-contact-pref">
    <legend className="text-[14px] font-semibold text-ink">Hoe mogen wij contact opnemen? <span className="font-normal text-slate-500">(optioneel)</span></legend>
    <div className="mt-1.5 grid grid-cols-3 gap-2">
      {PREFS.map(([v, l]) => <Choice key={v} name="isde-rr-pref" value={v} label={l} checked={pref === v} onChange={onPref} testid={`isde-review-pref-${v}`} />)}
    </div>
    {pref === "telefoon" && (
      <fieldset className="mt-3" data-testid="isde-review-contact-moment">
        <legend className="text-[13.5px] font-semibold text-ink">Wanneer bent u het best bereikbaar?</legend>
        <div className="mt-1.5 grid grid-cols-2 gap-2 sm:grid-cols-4">
          {MOMENTS.map(([v, l, h]) => <Choice key={v} name="isde-rr-moment" value={v} label={l} hint={h} checked={moment === v} onChange={onMoment} testid={`isde-review-moment-${v}`} />)}
        </div>
      </fieldset>
    )}
    <p className="mt-1.5 text-[12.5px] text-slate-500">Dit is alleen uw voorkeur, geen afspraak. Wij nemen zelf contact met u op.</p>
  </fieldset>
);
